





































































import {
  GdprAssociationsDef,
  GdprValuesDef,
  SelectOptionDef
} from "@/model/component.model";
import {
  AssociationElementNames,
  associationElementNames,
  associationKeys,
  GdprAssociationDto,
  GdprVersionElementsDTO,
  GdprVersionsDto,
  UuidData
} from "@/model/data.model";
import { GdprService } from "@/services/GdprService";
import {
  downloadFile,
  getCurrentLoginByCustomTenantId
} from "@/services/Helpers";
import { GdprErrorHandler } from "@/utils/GdprErrorHandler";
import * as equal from "fast-deep-equal";
import cloneDeep from "lodash/cloneDeep";
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import GdprSimple from "./GdprSimple.vue";
const gdprLandingPageSourceDescription = "Online Procedure";
import { getCountryOrCompanyNameLabelBasedOnTenant } from "@/services/Helpers";

export type ConsentSections = "vision" | "otherConsents";

export type ConsentSectionsVersion = {
  [key in ConsentSections]: number;
};

export type ConsentSectionsBoolean = {
  [key in ConsentSections]: boolean;
};

import { format, parse } from "date-fns";

@Component({
  components: {
    GdprSimple: GdprSimple
  }
})
export default class ConsentRenewalShowPage extends Vue {
  originalGdprValues = {} as GdprAssociationsDef;
  gdprAssociations: GdprAssociationDto[] = [];

  gdprValues: GdprAssociationsDef = {
    vision: {
      value: 0,
      date: "",
      source: { label: "", value: "" },
      element: 1
    },
    mktgCenter: {
      value: 0,
      date: "",
      source: { label: "", value: "" },
      element: 2
    },
    mktgCorporate: {
      value: 0,
      date: "",
      source: { label: "", value: "" },
      element: 3
    },
    profiling: {
      value: 0,
      date: "",
      source: { label: "", value: "" },
      element: 4
    },
    cession: {
      value: 0,
      date: "",
      source: { label: "", value: "" },
      element: 5
    }
  } as GdprAssociationsDef;
  uuidData = {} as UuidData;
  commonLandingPageSource = {} as SelectOptionDef;
  gdprSources = {};
  gdprAllVersions = [] as GdprVersionsDto[];
  wereAssociationsEmpty = false;
  elementVersionsList = {} as GdprVersionElementsDTO;
  originalConsentsConfirmation = {
    vision: true,
    otherConsents: false
  } as ConsentSectionsBoolean;
  consentsConfirmation = {
    vision: true,
    otherConsents: false
  } as ConsentSectionsBoolean;
  wasViewSaved = false;

  get hideConsentAgreement() {
    return {
      vision:
        this.consentsConfirmation.vision &&
        this.originalConsentsConfirmation.vision,
      otherConsents:
        this.consentsConfirmation.otherConsents &&
        this.originalConsentsConfirmation.otherConsents
    } as ConsentSectionsBoolean;
  }

  get isGermany() {
    return getCurrentLoginByCustomTenantId(this.uuidData.tenantId).isGermany;
  }

  get isSaveButtonEnabled() {
    const isDirtyOtherConsents =
      this.originalConsentsConfirmation.otherConsents !=
      this.consentsConfirmation.otherConsents;

    return (
      (isDirtyOtherConsents && this.consentsConfirmation.otherConsents) ||
      !this.wasViewSaved
    );
  }

  get hasDirtyValues() {
    return (
      this.hasDirtyValuesSections.vision ||
      this.hasDirtyValuesSections.otherConsents
    );
  }

  get hasDirtyValuesSections() {
    const {
      vision: removedVision,
      ...originalValuesWithoutVision
    } = this.originalGdprValues;
    const { vision: removedVision2, ...valuesWithoutVision } = this.gdprValues;
    return {
      vision: !equal(this.originalGdprValues.vision, this.gdprValues.vision),
      otherConsents: !equal(originalValuesWithoutVision, valuesWithoutVision)
    };
  }

  get uuid() {
    return this.$route.params.id;
  }

  get isDev() {
    return this.$store.getters.envs.isDev;
  }

  get breadcrumbName() {
    if (!this.uuidData) return null;
    const hasFirstNameOrLastName =
      !!this.uuidData.firstName || !!this.uuidData.lastName;
    return hasFirstNameOrLastName
      ? `${this.uuidData.firstName ?? ""} ${this.uuidData.lastName ?? ""}`
      : this.uuidData.businessName;
  }

  get latestVersion() {
    const latestVersion = {
      vision: -1,
      otherConsents: -1
    } as ConsentSectionsVersion;

    const visionKey = this.normalizeLabel("VISION");
    for (const version of this.gdprAllVersions) {
      const versionValues = Object.values(version.elements);
      if (latestVersion.vision === -1 && versionValues.includes(visionKey)) {
        latestVersion.vision = version.policyVersion;
      }
      const containsAnyOtherElementThanVision = !!versionValues.filter(
        valueKey => valueKey !== visionKey
      ).length;
      if (
        latestVersion.otherConsents === -1 &&
        containsAnyOtherElementThanVision
      ) {
        latestVersion.otherConsents = version.policyVersion;
      }
      if (latestVersion.vision !== -1 && latestVersion.otherConsents !== -1) {
        break;
      }
    }
    return latestVersion;
  }

  get latestElements() {
    const latestElements = {} as GdprVersionElementsDTO;
    for (const version of this.gdprAllVersions) {
      const latestElementsValues = Object.values(latestElements);
      if (latestElementsValues.length === associationElementNames.length) {
        break;
      }

      const versionElements = version.elements;
      for (const elementKey in versionElements) {
        const elementValue = versionElements[elementKey];
        if (!latestElementsValues.includes(elementValue)) {
          latestElements[elementKey] = elementValue;
        }
      }
    }

    return latestElements;
  }

  get currentVersion() {
    const currentVersion = {} as ConsentSectionsVersion;

    const visionKey = "VISION";
    const elementNamesWithoutVision = associationElementNames.filter(
      elementName => elementName !== visionKey
    );

    const visionVersion = this.gdprValues[associationKeys[visionKey]]
      .policyVersion;
    currentVersion.vision = visionVersion || -1;

    currentVersion.otherConsents =
      this.gdprValues[associationKeys[elementNamesWithoutVision[0]]]
        .policyVersion || -1;

    for (let index = 1; index < elementNamesWithoutVision.length; index++) {
      const returnIfAnyPolicyWasUndefined = currentVersion.otherConsents === -1;
      if (returnIfAnyPolicyWasUndefined) break;

      const iterationElementKey =
        associationKeys[elementNamesWithoutVision[index]];
      const iterationElementVersion = this.gdprValues[iterationElementKey]
        .policyVersion;
      if (!iterationElementVersion) {
        currentVersion.otherConsents = -1;
      } else if (iterationElementVersion < currentVersion.otherConsents) {
        currentVersion.otherConsents = iterationElementVersion;
      }
    }

    return currentVersion;
  }

  get hasLatestVersion() {
    return {
      vision:
        this.currentVersion.vision === this.latestVersion.vision &&
        !this.wereAssociationsEmpty,
      otherConsents:
        this.currentVersion.otherConsents ===
          this.latestVersion.otherConsents && !this.wereAssociationsEmpty
    } as ConsentSectionsBoolean;
  }

  async created() {
    this.updateOriginalAssociations();
    await this.getUuidData();
    this.updateLanguage();
    await Promise.all([this.getGdprElements(), this.getGdprSources()]);
    this.setElementsVersionsList();
    await this.getGdprAssociationsByUuid();
    this.initConsentsConfirmation();
    this.updateOriginalAssociations();
  }

  @Watch("hasDirtyValuesSections") onViewBecomeDirty(
    newVal: ConsentSectionsBoolean,
    oldVal: ConsentSectionsBoolean
  ) {
    const wereBothConsentAgreementsHidden =
      this.hideConsentAgreement.vision &&
      this.hideConsentAgreement.otherConsents;

    if (wereBothConsentAgreementsHidden) {
      if (newVal.vision) {
        this.consentsConfirmation.vision = false;
        this.originalConsentsConfirmation.vision = false;
      }
      if (newVal.otherConsents) {
        this.consentsConfirmation.otherConsents = false;
        this.originalConsentsConfirmation.otherConsents = false;
      }
    }
  }

  initConsentsConfirmation() {
    let newAcnowledgementValue = this.hasLatestVersion.vision;

    if (
      this.gdprValues.vision.value === -1 ||
      this.gdprValues.vision.value === 0
    ) {
      newAcnowledgementValue = false;
    }
    this.consentsConfirmation.vision = newAcnowledgementValue;
    this.updateOriginalConsentsConfirmation();
  }

  updateOriginalConsentsConfirmation() {
    this.originalConsentsConfirmation = { ...this.consentsConfirmation };
  }

  updateOriginalAssociations() {
    this.originalGdprValues = cloneDeep(this.gdprValues);
  }

  onModifiedGdprAssociationsChange(newGdprAssociations: GdprAssociationsDef) {
    this.gdprValues = newGdprAssociations;
  }

  updateLanguage() {
    if (this.uuidData.language) {
      const language = this.uuidData.language.toLowerCase();
      this.$store.dispatch("updateLanguage", { lang: language });
    }
  }

  async onDownloadPrivacyPolicy(policyVersion: number) {
    try {
      const version: GdprVersionsDto = this.gdprAllVersions.find(
        version => version.policyVersion === this.latestVersion.vision
      );
      if (!version.attachmentId) {
        throw new Error(this.$i18n.t("gdpr_privacy_download_error"));
      }

      const file = await GdprService.prototype.getPrivacyPolicyFile(
        version.attachmentId,
        this.uuidData.tenantId
      );

      const fileName = `${version.name.replace(" ", "_")}.pdf`;

      downloadFile(file, "application/pdf", fileName, this);
    } catch (error) {
      this.$notify.error(this.$i18n.t("gdpr_privacy_download_error"));
    }
  }

  async getUuidData() {
    const response = await GdprService.prototype.getUuidData(this.uuid);
    if (response) this.uuidData = { ...response };
  }

  async getGdprAssociationsByUuid() {
    this.initializeEmptyAssociations();
    const response = await GdprService.prototype.getAssociationsByUuid(
      this.uuid
    );
    if (response && response.length) {
      this.extractLatestAssociations(response);
    } else {
      this.wereAssociationsEmpty = true;
    }
  }

  extractLatestAssociations(associations: GdprAssociationDto[]) {
    const sortedAssociations = this.sortAssociations(associations);

    associationElementNames.forEach(elementName => {
      const association = sortedAssociations.find(associationDTO => {
        const normalizedLabel = this.normalizeLabel(
          associationDTO.gdprElement.name
        );
        return normalizedLabel === elementName;
      }) as GdprAssociationDto;
      if (association) {
        const idGdprElement = association.idGdprElement;
        const matchedAssociationKey = associationKeys[elementName];
        const gdprValue: GdprValuesDef = {
          element: idGdprElement,
          value: association.value,
          source: {
            label: " ",
            value: association.idGdprSource
          } as SelectOptionDef,
          date: parse(
            association.associationDateTime,
            "dd/MM/yyyy HH:mm",
            new Date()
          ),
          policyVersion: Number(this.elementVersionsList[idGdprElement]),
          idGdprAssociation: association.idGdprAssociation,
          name: elementName
        };
        this.gdprValues[matchedAssociationKey] = cloneDeep(gdprValue);
      }
    });
  }

  sortAssociations(associations: GdprAssociationDto[]) {
    return associations.sort((a: GdprAssociationDto, b: GdprAssociationDto) => {
      return (
        new Date(b.creationDate).getTime() - new Date(a.creationDate).getTime()
      );
    });
  }

  initializeEmptyAssociations() {
    associationElementNames.forEach(elementName => {
      const associationKey = associationKeys[elementName];
      const [lastestElementKey] = this.findLatestElement(elementName);

      const matchedAssociation = this.gdprValues[associationKey];
      matchedAssociation.source = { ...this.commonLandingPageSource };
      matchedAssociation.idRefAddress = this.uuidData.idRefContact;
      matchedAssociation.element = Number(lastestElementKey);
      matchedAssociation.date = new Date().toISOString();
    });
  }

  normalizeLabel(label: string) {
    return label.toUpperCase().replace(" ", "_");
  }

  async getGdprSources() {
    const response = await GdprService.prototype.getSourcesByUuid(this.uuid);
    if (response) {
      this.gdprSources = { ...response };
      // Landing page should have source updated to source that has gdprLandingPageSourceDescription in case of element change
      let commonLandingPageSource = null;
      for (const [sourceId, sourceLabel] of Object.entries(response)) {
        if (sourceLabel === gdprLandingPageSourceDescription) {
          commonLandingPageSource = {
            value: Number(sourceId),
            label: sourceLabel
          };
          break;
        }
      }
      if (commonLandingPageSource) {
        this.commonLandingPageSource = { ...commonLandingPageSource };
      }
    }
  }

  async getGdprElements() {
    const response = await GdprService.prototype.getElementsByUuid(this.uuid);
    if (response) this.gdprAllVersions = [...response];
  }

  async saveGdprAssociationsByUuid(associationsValues: GdprAssociationsDef) {
    try {
      const response = await GdprService.prototype.createAssociationsByUuid(
        associationsValues,
        "LANDING_PAGE",
        this.uuid,
        this.uuidData.idRefContact
      );
      if (response) {
        this.extractLatestAssociations(response);
        this.updateOriginalAssociations();
        this.updateOriginalConsentsConfirmation();
        this.wereAssociationsEmpty = false;
        this.wasViewSaved = true;
        this.$notify.success(this.$t("changes_saved"));
      }
    } catch (err) {
      const message = new GdprErrorHandler(err).message;
      this.$notify.error(message);
    }
  }

  findLatestElement(elementName: AssociationElementNames) {
    const latestElementsEntries = Object.entries(this.latestElements);
    const matchedLatestElement = latestElementsEntries.find(
      ([latestElementKey, latestElementLabel]) =>
        this.normalizeLabel(latestElementLabel) === elementName
    );
    if (!matchedLatestElement) {
      throw new Error(`Failed to update policy version`);
    }

    return matchedLatestElement;
  }

  async setElementsVersionsList() {
    if (!this.gdprAllVersions.length) return;
    let elementVersions = {} as GdprVersionElementsDTO;
    this.gdprAllVersions.forEach((item: GdprVersionsDto) => {
      if (item.elements) {
        const currentVersion = item.policyVersion;
        Object.keys(item.elements).forEach((elementId: string) => {
          elementVersions = {
            ...elementVersions,
            [elementId]: currentVersion
          };
        });
      }
    });
    this.elementVersionsList = elementVersions;
  }
  // Function for testing purpose only
  async rollBackVersion() {
    try {
      const originalElementsCopy = cloneDeep(this.originalGdprValues);

      associationElementNames.forEach(elementName => {
        const oldestElements = cloneDeep(this.gdprAllVersions).pop().elements;
        const latestElementsEntries = Object.entries(oldestElements);
        const [matchedElementKey] = latestElementsEntries.find(
          ([latestElementKey, latestElementLabel]) =>
            this.normalizeLabel(latestElementLabel) === elementName
        );

        const elementAssociationName = associationKeys[elementName];

        originalElementsCopy[elementAssociationName].element = Number(
          matchedElementKey
        );
      });

      await this.saveGdprAssociationsByUuid(originalElementsCopy);
      const resetConsentConfirmation = {
        vision: false,
        otherConsents: false
      };
      this.consentsConfirmation = { ...resetConsentConfirmation };
      this.originalConsentsConfirmation = { ...resetConsentConfirmation };
      this.wasViewSaved = false;
    } catch (error) {
      throw new Error(`Failed to roll back version`);
    }
  }

  onViewSave() {
    if (!this.consentsConfirmation.otherConsents) {
      this.$alerts.danger(
        this.$i18n.t("gdpr_other_consents_not_confirmed_alert", {
          contryOrCompanyName: this.countryOrCompanyNameLabel
        })
      );
    } else {
      this.saveView();
    }
  }

  saveView() {
    const valuesCopy = cloneDeep(this.gdprValues);
    const manipulatedValues = this.manipulateValuesBasedOnConsentAgreement(
      valuesCopy
    );
    const { updatedAssociationValues } = manipulatedValues;
    const { hasEmptyValueInOtherConsents } = manipulatedValues;

    if (hasEmptyValueInOtherConsents) {
      this.$alerts.danger(
        this.$i18n.t("gdpr_other_cosents_contain_empty_value")
      );
      return;
    } else if (
      updatedAssociationValues.mktgCenter.value !== 1 &&
      updatedAssociationValues.mktgCorporate.value !== 1
    ) {
      this.$alerts
        .confirm(
          this.$i18n.t("gdpr_empty_marketing_consents_alert", {
            contryOrCompanyName: this.countryOrCompanyNameLabel
          })
        )
        .then((confirm: boolean) => {
          if (confirm) {
            this.saveGdprAssociationsByUuid(updatedAssociationValues);
          }
        });
    } else {
      this.updateAssociationDatesAndSaveView(updatedAssociationValues);
    }
  }

  updateAssociationDatesAndSaveView(updatedAssociationValues) {
    const updatedAssociationValuesAndDate = this.updateAssociationDate(
      updatedAssociationValues
    );

    this.saveGdprAssociationsByUuid(updatedAssociationValuesAndDate);
  }

  manipulateValuesBasedOnConsentAgreement(
    associationsValues: GdprAssociationsDef
  ) {
    let hasEmptyValueInOtherConsents = false;
    const updatedAssociationValues = {} as GdprAssociationsDef;
    const shouldUpdateVisionVersion = true;
    const shouldUpdateOtherConsentsVersion = this.consentsConfirmation
      .otherConsents;
    const visionKey = "VISION";
    const associationKeysToUpdate = [] as AssociationElementNames[];
    if (shouldUpdateVisionVersion) {
      associationKeysToUpdate.push(visionKey);
      associationsValues.vision.value = 1;
      associationsValues.vision.date = new Date().toISOString();
      associationsValues.vision.source = {
        ...this.commonLandingPageSource
      };
    }
    if (shouldUpdateOtherConsentsVersion) {
      const elementNamesWithoutVision = associationElementNames.filter(
        elementName => elementName !== visionKey
      );
      associationKeysToUpdate.push(...elementNamesWithoutVision);
    }

    associationKeysToUpdate.forEach(elementName => {
      const [matchedElement] = this.findLatestElement(elementName);
      const elementAssociationName = associationKeys[elementName];

      updatedAssociationValues[elementAssociationName] =
        associationsValues[elementAssociationName];
      updatedAssociationValues[elementAssociationName].element = Number(
        matchedElement
      );
      const date = format(new Date(), "dd/MM/yyyy HH:mm");

      updatedAssociationValues[elementAssociationName].date = parse(
        date,
        "dd/MM/yyyy HH:mm",
        new Date()
      );

      if (updatedAssociationValues[elementAssociationName].value === -1) {
        hasEmptyValueInOtherConsents = true;
      }
    });

    return { updatedAssociationValues, hasEmptyValueInOtherConsents };
  }

  updateAssociationDate(associationsValues: GdprAssociationsDef) {
    for (const key of Object.keys(associationsValues)) {
      associationsValues[key].date = new Date().toISOString();
    }
    return associationsValues;
  }

  get countryOrCompanyNameLabel() {
    return getCountryOrCompanyNameLabelBasedOnTenant(this.uuidData.tenantId);
  }
}
